export const stats = [
  {
    'user_uuid': 'ec4de62a-cecc-40e8-b066-8a7297633d5c',
    'red': 5,
    'yellow': 10,
    'green': 347
  }
]



// WEBPACK FOOTER //
// ./src/_helpers/backend-data/stats.js